import {Suspense} from 'react'
import {CopilotCodeReviewFindings} from '@github-ui/copilot-code-review-findings'
import {useFindingsQuery} from './data/route-queries'
import styles from './Findings.module.css'

/** Findings section — suspends while deferred data loads */
export function Findings() {
  return (
    <Suspense fallback={null}>
      <FindingsContent />
    </Suspense>
  )
}

function FindingsContent() {
  const {data} = useFindingsQuery()
  return (
    <div className={styles.list}>
      <CopilotCodeReviewFindings {...data} />
    </div>
  )
}
